import React from 'react';
import { resolveTestimonialVideo } from '../utils/testimonialVideo';

const FALLBACK_THUMB =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjkwIiB2aWV3Qm94PSIwIDAgMTIwIDkwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB3aWR0aD0iMTIwIiBoZWlnaHQ9IjkwIiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik00OCA0MEw3MiA1NUw0OCA3MFY0MFoiIGZpbGw9IiM2QjcyODAiLz4KPC9zdmc+';

const TestimonialVideoBlock = ({ item, name }) => {
  const video = resolveTestimonialVideo(item);
  if (item?.type !== 'video' || !video) return null;

  return (
    <div className="video-testimonial">
      <div
        className="youtube-video-container"
        onClick={() => window.open(video.watchUrl, '_blank', 'noopener,noreferrer')}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            window.open(video.watchUrl, '_blank', 'noopener,noreferrer');
          }
        }}
        role="button"
        tabIndex={0}
        style={{
          position: 'relative',
          cursor: 'pointer',
          borderRadius: '8px',
          overflow: 'hidden',
          marginBottom: '1rem',
        }}
      >
        <img
          src={video.thumbnail}
          alt={`Témoignage vidéo de ${name}`}
          style={{ width: '100%', height: '200px', objectFit: 'cover' }}
          onError={(e) => {
            e.target.src = FALLBACK_THUMB;
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            color: '#ff0000',
            fontSize: '3rem',
            textShadow: '0 2px 8px rgba(0,0,0,0.8)',
          }}
        >
          <i className="fab fa-youtube" aria-hidden="true" />
        </div>
      </div>
    </div>
  );
};

export default TestimonialVideoBlock;
